// extracted by mini-css-extract-plugin
export var articlePreviewWrapper = "ArticlePreview-module--articlePreviewWrapper--9MzUQ";
export var moreTextButton = "ArticlePreview-module--moreTextButton--2acGy";
export var title = "ArticlePreview-module--title--ySnkz";
export var description = "ArticlePreview-module--description--fXmcM";
export var imageWrapper = "ArticlePreview-module--imageWrapper--3tICD";
export var articleImage = "ArticlePreview-module--articleImage--2j6TE";
export var categorySection = "ArticlePreview-module--categorySection--uw1nw";